function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.815 5.092l.08.085 1.657 1.942 2.374 8.86c.93.07 1.74.566 2.24 1.292l7.39-1.98 2.077.586.113.03a1 1 0 01.685 1.033l-.016.116-.03.113a1 1 0 01-1.033.685l-.115-.016-1.617-.494-6.937 1.86a3 3 0 11-4.69-2.708L4.737 8.072 3.374 6.474A1 1 0 013.4 5.145l.085-.08a1 1 0 011.329.027zM8.692 17.97a1 1 0 100 2 1 1 0 000-2zM16 5.804a1 1 0 01.366 1.366l-1.5 2.598 2.598 1.5a1 1 0 01-1 1.732l-2.598-1.5-1.5 2.598a1 1 0 01-1.732-1l1.5-2.598L9.536 9a1 1 0 111-1.732l2.598 1.5 1.5-2.598A1 1 0 0116 5.804z"
});

var SvgProviderX = function SvgProviderX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProviderX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/provider-x.3ac89556.svg";
export { ForwardRef as ReactComponent };